export const ANALYSIS_ID = 'analysis_id';
export const WX_OPEN_ID = 'WX_OPEN_ID';
export const WX_CODE = 'WX_CODE';
export const IOS_PAY_PARAM_CACHE = 'IOS_PAY_PARAM_CACHE';
export const USERCENTER_TICKET = 'usercenter_t';
export const MSITE_HDCN = 'HDCN';
export const MSITE_UUID = 'uuid';
export const RETURN_URL = "MGTV_CASHIER_RETURN_URL";



// WEBPACK FOOTER //
// ./src/constant/CookieKeys.js